<template>
    <div class="theme_common_bg_section">
        <div class="common_page_header">
            <button type="button" tapable="" class="btn btn-white-transparent back_btn"><i aria-hidden="true"
                    class="fa fa-chevron-left"></i></button> Staff
        </div>
        <div class="common_page_body">
            <div class="staff_filter_list">
                <carousel :mouseDrag="sliderTouchDrag" :touchDrag="sliderTouchDrag" :autoplay="false" :loop="false"
                    :nav="false" :margin="15" :dots="false" :items="4"
                    :responsive="{ 1900: { items: 6 }, 1600: { items: 4 }, 1025: { items: 4 }, 560: { items: 2 }, 320: { items: 1 } }"
                    v-model="totalCountOfFilters" v-once>
                    <template slot="prev">
                        <span class="staff_slider_arrow member_slider_prev"><i class="fa fa-angle-left"
                                aria-hidden="true"></i></span>
                    </template>
                    <div class="carousel_item animation_zoom_out"
                        v-for="(filterSlideItems, index) in totalCountOfFilters" :key="filterSlideItems.id">
                        <div class="total_count_box"
                            @click="filteredMemberList(filterSlideItems.filter_key, filterSlideItems.count)"
                            :id="'filtered' + filterSlideItems.filter_key" :class="index == '0' ? 'active' : ''">
                            <div class="count_icon">
                                <span class="filter_cat_img_box">
                                    <img :src="filterSlideItems.image" class="img-fluid">
                                </span>
                            </div>
                            <div class="count_title_w_n">
                                <span class="count_number" v-if="totalCountOfFilters"><template
                                        v-if="filterSlideItems.count">{{ filterSlideItems.count }}</template><template
                                        v-else>0</template></span>
                                <span class="count_title">
                                    <div v-html="filterSlideItems.display_name" class="global_filter_name_in_html">
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                    <template slot="next"><span class="staff_slider_arrow staff_slider_next"><i
                                class="fa fa-angle-right" aria-hidden="true"></i></span></template>
                </carousel>
            </div>
            <div class="custom_styling_table">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th width="30%">Name</th>
                                <th width="20%" class="text-center">Country</th>
                                <th width="20%" class="text-center">City</th>
                                <th width="20%" class="text-center">Role</th>
                                <th width="20%" class="text-right">Action</th>
                            </tr>
                            <tr class="empty_cell">
                                <th colspan="7"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="m_u_info">
                                    <span class="member_user_avtaar">
                                        <a href="javascript:void(0)">
                                            <img src="@/assets/images/user2.png" class="img-fluid" width="50">
                                        </a>
                                    </span>
                                    <span class="member_user_info">
                                        <span class="member_user_name">
                                            <a href="javascript:void(0)">Ms Aanchal Bhattacharya</a>
                                        </span>
                                    </span>
                                </td>
                                <td class="m_u_country_flag text-center">
                                    <img src="https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/in.png"
                                        class="country-flag">
                                </td>
                                <td class="text-center">Kolkata</td>
                                <td width="20%" class="text-center">-</td>
                                <td class="role_a_btn text-right">
                                    <label class="badge badge-secondary" @click="rolesPermissionPopupmethod">Roles & Permission</label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <roles-permission-popup v-if="rolesPermissionPopup"></roles-permission-popup>
    </div>
</template>

<script>
/*eslint-disable */
import { bus } from '@/main';
import rolesPermissionPopup from '@/components/private/roles-permission-popup/';
import carousel from 'vue-owl-carousel'
import staff from '@/assets/images/icon/staff.png';
import image from '@/assets/images/icon/cc_icon.png';
import image1 from '@/assets/images/icon/ad_icon.png';
import image2 from '@/assets/images/icon/d_icon.png';
import image4 from '@/assets/images/icon/m_icon.png';
export default {
    name: 'member-all-user-list',
    components: {
        carousel,
        'roles-permission-popup': rolesPermissionPopup
    },
    data() {
        return {
            sliderTouchDrag: false,
            rolesPermissionPopup: false,
            totalCountOfFilters:
                [{
                    "id": "0ecbf47c-b19a-4f83-ac32-fce71880326d2",
                    "display_name": "<p>Staff</p>",
                    "image": staff,
                    "count": 1,
                },
                {
                    "id": "0ecbf47c-b19a-4f83-ac32-fce71880326d",
                    "display_name": "<p>Content Creator</p>",
                    "image": image,
                    "count": 1,
                },
                {
                    "id": "94f52e65-8993-44b4-bd48-908f67a2cdbc",
                    "display_name": "<p>Management</p>",
                    "image": image4,
                    "count": 1,
                },
                {
                    "id": "3f838880-c41c-4158-9b07-aee71a3f514f",
                    "display_name": "<p>Developer</p>",
                    "image": image2,
                    "count": 1,
                },
                {
                    "id": "3f838880-c41c-4158-9b07-aee71a3f514f1",
                    "display_name": "<p>Super Admin</p>",
                    "image": image1,
                    "count": 1,
                }]
        }
    },
    mounted() {
        bus.$on('rolesPermissionPopupStateBus', (data) => {
            this.rolesPermissionPopup = data;
        });
    },
    methods: {
        rolesPermissionPopupmethod() {
            this.rolesPermissionPopup = true;
        }
    }
}
</script>

<style lang="scss" scoped>
.theme_common_bg_section {
    background: rgba(0, 0, 0, 0.7);
    margin-bottom: 0;
    border-radius: 5px;
    min-height: calc(100vh - 96px);
    position: relative;
    overflow: hidden;

    .common_page_header {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        border-bottom: solid 1px rgba(228, 233, 237, 0.1);
        position: relative;
        font-family: 'MyriadProSemibold', 'Lato', sans-serif;
        font-weight: normal;
        font-size: 22px;
        padding: 10px 15px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .common_page_body {
        padding: 15px 30px;

        .staff_filter_list {
            padding: 12px 0;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            position: relative;

            .total_count_box {
                background: rgba(228, 233, 237, 0.1);
                padding: 0 0 35px 18px;
                border-radius: 5px;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: flex-end;
                -ms-flex-align: flex-end;
                align-items: flex-end;
                cursor: pointer;
                color: #fff;
                height: 135px;

                &:hover {
                    background: #3be8b0;
                    color: #000000;
                }

                &:hover .count_icon path {
                    fill: #000000;
                }

                &:hover .count_icon circle {
                    fill: #000000;
                }

                &:hover .count_icon rect {
                    fill: #000000;
                }

                &:hover .count_icon span {
                    background: rgba(0, 0, 0, 0.1)
                }

                &.active {
                    background: #3be8b0;
                    color: #000000;
                }

                &.active .count_icon path {
                    fill: #000000;
                }

                &.active .count_icon circle {
                    fill: #000000;
                }

                &.active .count_icon rect {
                    fill: #000000;
                }

                &.active .count_icon span {
                    background: rgba(255, 255, 255, 0.15);
                }

                &:hover .count_icon span .img-fluid {
                    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
                    -webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
                }

                &.active .count_icon span .img-fluid {
                    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
                    -webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
                }
            }

            .count_icon span {
                width: 60px;
                display: inline-block;
                height: 60px;
                background: hsla(0, 0%, 100%, .1);
                border-radius: 50%;
                text-align: center;
                line-height: 60px;

                .img-fluid {
                    width: 40px;
                    display: inline-block;
                }
            }

            .count_title_w_n {
                padding-left: 15px;
            }

            .count_number {
                display: block;
                font-size: 22px;
                font-weight: 600;
            }

            .count_title {
                font-size: 20px;
                text-transform: capitalize;
                line-height: 1;
            }

            .row .col-sm-3 {
                padding-left: 6px;
                padding-right: 6px;
            }

            .row {
                margin-left: -6px;
                margin-right: -6px;
            }
        }

        .staff_slider_arrow {
            position: absolute;
            z-index: 99;
            top: 50%;
            left: -21px;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);

            .fa {
                cursor: pointer;
                font-size: 42px;
                line-height: 28px;
                color: #ffc107;

                &:hover {
                    color: #3be8b0;
                }
            }

            @media only screen and (max-width:767px) {
                left: -15px;
            }

            &.staff_slider_next {
                right: -21px;
                left: auto;

                @media only screen and (max-width:767px) {
                    right: -15px;
                }
            }
        }

        .custom_styling_table {
            .table {
                margin-bottom: 0;
                letter-spacing: 0.5px;
                color: #ffffff;
                border-collapse: separate;
                border-spacing: 0 3px;

                thead th {
                    border-bottom: 0;
                    font-size: 19px;
                    padding: 10px 8px;
                    font-family: 'MyriadProRegular', 'Lato', sans-serif;
                    text-transform: uppercase;
                    border-top: 0px;
                    transition: all ease 0.5s;
                    -webkit-transition: all ease 0.5s;
                    -moz-transition: all ease 0.5s;
                    background: rgba(228, 233, 237, .1);
                    color: #3be8b0;
                }

                thead .empty_cell th {
                    padding: 0px !important;
                    background: none !important;
                }

                tbody td {
                    color: #ffffff;
                    vertical-align: middle;
                    padding: 10px 8px;
                    font-size: 20px;
                    font-family: 'MyriadProRegular', 'Lato', sans-serif;
                    transition: all ease 0.5s;
                    -webkit-transition: all ease 0.5s;
                    -moz-transition: all ease 0.5s;
                    height: 80px;
                    border-top: 0px;
                    background: rgba(228, 233, 237, .1);
                }

                a:hover {
                    text-decoration: none;
                }

                .member_user_avtaar {
                    display: inline-block;
                    vertical-align: middle;
                    position: relative;

                    img {
                        width: 60px;
                        height: 60px;
                        border-radius: 50%;
                        cursor: pointer;
                    }
                }

                .online-status {
                    position: absolute;
                    right: 4px;
                    bottom: 2px;
                    border: 1px solid #9E9E9E;
                    border-radius: 50%;
                    width: 12px;
                    height: 12px;
                    background: #9E9E9E;

                    &.online {
                        background-color: #4CAF50;
                        border-color: #4CAF50;
                    }

                    &.busy {
                        background-color: #F44336;
                        border-color: #F44336;
                    }
                }

                .member_user_info {
                    display: inline-block;
                    vertical-align: middle;
                    width: calc(100% - 70px);
                    margin-left: 10px;
                }

                .member_user_name {
                    line-height: 1;
                    font-size: 20px;
                    color: #fff;
                    display: block;
                    cursor: pointer;
                    text-transform: capitalize;
                    transition: all ease 0.5s;
                    -webkit-transition: all ease 0.5s;
                    -moz-transition: all ease 0.5s;

                    a {
                        color: #ffffff;
                        text-decoration: none;
                        text-transform: capitalize;

                        &:hover {
                            color: #ffd400;
                        }
                    }
                }

                .member_join_date {
                    line-height: 1;
                    font-size: 16px;
                    color: #fff;
                    display: block;
                }

                .member_user_email,
                .member_join_time {
                    font-size: 15px;
                    color: hsla(0, 0%, 100%, .5);
                    white-space: pre-wrap;
                    word-break: break-all;
                    display: block;
                }

                .country-flag {
                    width: 50px;
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 5px;
                    // height: 64px;
                    object-fit: cover;
                }

                .country-flag-name {
                    width: calc(100% - 55px);
                    display: inline-block;
                    vertical-align: middle;
                    line-height: 1.2;
                }
            }
        }

        .role_a_btn {
            .badge {
                font-weight: normal;
                cursor: pointer;

                &:hover {
                    background: #3be8b0;
                    color: #000000;
                }
            }
        }
    }
}
</style>